import ATTBannerLogo from './ATTBannerLogo';
export default ATTBannerLogo;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/core/components/ATTBannerLogo/index.js
// module id = 2396
// module chunks = 8